import React, {useRef, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TimelineLite } from 'gsap';

const GalleryLightbox = ({
    image,
    currentItem,
    totalItems,
    handleGalleryPrevItem,
    handleGalleryNextItem,
    handleCloseGallery
}) => {
    const gallery = useRef();
    const [active, setActive] = useState(false);

    const tl = new TimelineLite();

    useEffect(() => {
        tl.set(gallery.current, { autoAlpha: 0 })
    }, [])

    useEffect(() => {
        if (image && !active) setActive(true);
    }, [image])

    useEffect(() => {
        tl.to(gallery.current, 0.3, {
            autoAlpha: active ? 1 : 0,
            onComplete: !active && handleCloseGallery
        });
    }, [active])

    return (
        <div className={classNames('gallery-lightbox')} ref={gallery}>
            <button className="gallery-lightbox-screen" onClick={() => setActive(false)} />
            <div className="gallery-lightbox-content">
                <div className="gallery-lightbox-img-wrapper">
                    <img src={image} alt={`${currentItem} of ${totalItems}`} />
                    <div className="gallery-lightbox-nav-btns">
                        <button className="gallery-prev-btn" onClick={handleGalleryPrevItem} />
                        <button className="gallery-next-btn" onClick={handleGalleryNextItem} />
                    </div>
                </div>
                <div className="gallery-lightbox-info">
                    <span>Image {currentItem} of {totalItems}</span>
                    <button className="gallery-close-btn" onClick={() => setActive(false)} />
                </div>
            </div>
        </div>
    )
}

GalleryLightbox.propTypes = {
    image: PropTypes.string,
    currentItem: PropTypes.number,
    totalItems: PropTypes.number,
    handleGalleryPrevItem: PropTypes.func,
    handleGalleryNextItem: PropTypes.func,
    handleCloseGallery: PropTypes.func
}

GalleryLightbox.defaultProps = {
    image: null,
    currentItem: 0,
    totalItems: 0,
    handleGalleryPrevItem: fn => fn,
    handleGalleryNextItem: fn => fn,
    handleCloseGallery: fn => fn
};

export default GalleryLightbox;
